import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { formatCurrency, formatCurrencySummation } from "../../Utils/rveoUtils";

/**
 * Hook para manejar la lógica de datos financieros
 */
export const useFinancialData = (
  saludData: any[],
  prestacionWatch?: string,
  coverage?: string,
  objSendForm?: any
) => {
  const methodFinancial = useForm({});

  const {
    handleSubmit: handleSubmitFinancial,
    register: registerFinancial,
    errors: errosFinancial,
    watch: watchFinancial,
    reset: resetFinancial,
    setValue: setValueFinancial,
    getValues: getValuesFinancial,
  } = methodFinancial;

  const cic = watchFinancial<any>("cic");
  const recogBonus = watchFinancial("recogBonus");
  const addContribution = watchFinancial("addContribution");
  const capitalPension = watchFinancial("capitalPension");
  const dateDeven = watchFinancial("dateDeven");
  const dateDevOrig = watchFinancial("dateDevOrig");
  const saludWatch = watchFinancial("salud");

  // useEffect para inicializar valores financieros
  useEffect(() => {
    setValueFinancial("cic", 30000);
    setValueFinancial("capitalPension", 30000);
    setValueFinancial("recogBonus", 0);
    setValueFinancial("addContribution", 0);
  }, []);

  // useEffect para sincronizar valores financieros desde objSendForm (solo al montar)
  useEffect(() => {
    if (objSendForm && objSendForm.cic) {
      setValueFinancial("cic", objSendForm.cic);
    }
    if (objSendForm && objSendForm.recogBonus) {
      setValueFinancial("recogBonus", objSendForm.recogBonus);
    }
    if (objSendForm && objSendForm.addContribution) {
      setValueFinancial("addContribution", objSendForm.addContribution);
    }
  }, []);

  // useEffect para calcular el capital de pensión
  useEffect(() => {
    let newCic = formatCurrencySummation(cic) || 0;
    let newRecogBonus = formatCurrencySummation(recogBonus) || 0;
    let newAddContribution = formatCurrencySummation(addContribution) || 0;
    let total = newCic + newRecogBonus + newAddContribution;
    setValueFinancial("capitalPension", formatCurrency(total));
  }, [cic, recogBonus, addContribution]);

  const capitalPensionRaw = formatCurrencySummation(capitalPension) || 0;

  return {
    methodFinancial,
    handleSubmitFinancial,
    registerFinancial,
    errosFinancial,
    resetFinancial,
    setValueFinancial,
    getValuesFinancial,
    cic,
    recogBonus,
    addContribution,
    capitalPension,
    capitalPensionRaw,
    dateDeven,
    dateDevOrig,
    saludWatch,
  };
};
